<template>
  <div class="row">
    <div class="col-12">
      <div class="new-button-div" style="padding-bottom: 20px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'Pedidos' }">{{
            $t("app.modules.orders.title")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            {{ $t("app.modules.orders.documents.documentation") }}
          </el-breadcrumb-item>

          <h6 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }} </h6>

        </el-breadcrumb>

        <td class="col-11"></td>
          <td class="col-2"><h7 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}  </h7></td>
        
      </div>
      <card card-body-classes="table-full-width" no-footer-line>
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <h4 class="card-title text-purple">
            {{ $t("app.modules.orders.documents.documentation") }}
          </h4>
        </div>
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <p>
            <b
              >{{
                $t("app.modules.orders.headers.delivery_address") + ": "
              }} </b
            >{{ item.destinoMercancia }}
          </p>
        </div>
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <p>
            <b>{{ $t("app.modules.orders.headers.order_number") + ": " }} </b
            >{{ item.numPedidoSAP }}
          </p>
        </div>
        <div
          class="col-12 d-flex justify-content-left justify-content-sm-left flex-wrap"
        >
          <el-table stripe style="width: 100%;" :data="productos">
            <el-table-column type="expand">
              <template slot-scope="{ row }">
                <p>
                  {{ $t("app.modules.orders.headers.code") }} :
                  {{ row.codigo }}
                </p>
                <p>
                  {{ $t("app.modules.orders.headers.description") }} :
                  {{ row.descripcion }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              min-width="250"
              :label="$t('app.modules.orders.headers.product')"
            >
              <template slot-scope="{ row }">
                {{ row.denominacion }}
              </template>
            </el-table-column>

            <el-table-column
              min-width="120"
              :label="$t('app.modules.orders.headers.price')"
            >
              <template slot-scope="{ row }">
                {{ row.importe }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="120"
              :label="$t('app.modules.orders.headers.money')"
            >
              <template slot-scope="{ row }">
                {{ row.moneda }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="120"
              :label="$t('app.modules.orders.headers.unit')"
            >
              <template slot-scope="{ row }">
                {{ row.unidad_medida }}
              </template>
            </el-table-column>

            <el-table-column
              min-width="240"
              :label="$t('app.modules.orders.headers.quantity')"
            >
              <template slot-scope="{ row }">
                {{ row.cantidad }}
              </template>
            </el-table-column>
            <el-table-column
              min-width="210"
              :label="$t('app.modules.orders.headers.delivery_date')"
            >
              <template slot-scope="{ row }">
                {{ row.fechaEntrega }}
              </template>
            </el-table-column>
            <el-table-column width="200">
              <div slot-scope="props" class="table-actions dropdown">
                <el-popover
                  placement="bottom"
                  width="300"
                  trigger="click"
                  :ref="'refOption' + props.$index"
                >
                  <div class="row">
                    <div class="col-12 options">
                      <n-button
                        @click.native="
                          AddDocsPedido(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.documents.add") }}
                      </n-button>
                      <n-button
                        @click.native="
                          PedidosDocs(
                            props.$index,
                            props.row,
                            'refOption' + props.$index
                          )
                        "
                        class="options-button"
                        type="primary"
                        size="sm"
                      >
                        {{ $t("app.modules.orders.documents.show") }}
                      </n-button>
                    </div>
                  </div>
                  <n-button
                    slot="reference"
                    size="sm"
                    icon
                    class="button-options-table"
                  >
                    <i class="fa fa-ellipsis-v" style="color:black;"></i>
                  </n-button>
                </el-popover>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </card>
      <pedidos-docs-add />
      <pedidos-docs-table />
    </div>
  </div>
</template>
<script>
import { array_set_value, getResponse } from "@/util/utilities";
import OrderItemInformationEdit from "@/models/pedidos/OrderItemEdit";
import ConstEstadoPedido from "@/models/pedidos/ConstEstadoPedido";
import { mapState } from "vuex";
export default {
  components: {
    PedidosDocsAdd: () => import("./pedidosDocsAdd"),
    PedidosDocsTable: () => import("./pedidosDocs")
  },
  data() {
    return {
      orden_data: [],
      historialPedido: [],
      files: [],
      productos: [],
      pedido: [],
      sizes: "col-lg-4 col-md-4 col-sm-6",
      idPedido: 0,
      item: {
        trad_esta: "",
        cliente: {},
        contactoCliente: {},
        usuarioServicioCliente: {},
        vendedor: {},
        productoCliente: {}
      },
      constEstadoPedido: new ConstEstadoPedido()
    };
  },
  mounted() {
    EventBus.$on("reload-items", () => {
      this.initPedidoPart();
    });
  },
  created() {
    // console.log(Object.entries(this.$route.params).length);
    if (Object.entries(this.$route.params).length == 0) {
      //No hay datos redireccionarlo
    } else {
      this.idPedido = this.$route.params.idPedido;
      this.initPedidoPart();
    }
  },
  methods: {
    async initPedidoPart() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getPedidoDetallePrinc();
      this.$swal.close();
    },
    async getPedidoDetallePrinc() {
      const params = {
        id: parseInt(this.idPedido),
        claveIdioma: this.$store.state.lang,
        usuario: this.$store.state.user.idUsuario,
        idPedido: parseInt(this.idPedido)
      };
      await this.$http.post(route("Pedidos/detallePedidoById"), params).then(
        async response => {
          if (response.body.code === 200) {
            this.item = response.body.pedido;
            let productos = productos || [];
            productos = this.item.detalles.map(product => {
              return new OrderItemInformationEdit({
                product,
                cantidad: product.cantidad,
                denominacion: product.productoCliente.denominacion,
                importe: product.productoCliente.importe,
                fechaEntrega: product.fechaEntregaSolicitada,
                idDetallePedido: product.idDetallePedido,

                direccion: this.item.destinoMercancia,
                codigo: product.productoCliente.material,
                descripcion: product.productoCliente.denominacion,
                unidad_medida: product.productoCliente.unidadMedida,
                moneda: product.productoCliente.moneda
              });
            });
            this.productos = productos;
            console.log(this.productos);
          } else {
            console.log(response.body);
            // this.processError(response.body)
          }
        },
        error => {
          console.error(error);
          // this.processError(error)
        }
      );
    },
    AddDocsPedido(index, row, ref) {
      this.$refs[ref].doClose();
      console.log(row);
      EventBus.$emit("pedidos-docs-add", { idPedido: row.idDetallePedido });
    },
    PedidosDocs(index, row, ref) {
      this.$refs[ref].doClose();
      console.log(row);
      EventBus.$emit("pedidos-docs-table", { idPedido: row.idDetallePedido });
    }
  }
};
</script>
